import useStepperPage from "@/shared/hooks/useStepperPage";
import { createPageTitle } from "@/shared/routing/TitleGuard";
import { RacwaStepperTemplate } from "@racwa/react-components";
import { RouteObject } from "react-router-dom";
import SafetyAndSecurityForm from "./Form";
import useSafetyAndSecurity from "./hooks/useSafetyAndSecurity";

export const pageName = "Your property's security";

export const SafetyAndSecurity: React.FC = () => {
  const props = useSafetyAndSecurity();
  const stepperProps = useStepperPage();

  return (
    <RacwaStepperTemplate {...stepperProps}>
      <SafetyAndSecurityForm {...props} />
    </RacwaStepperTemplate>
  );
};

export const SafetyAndSecurityRoute = {
  path: "safety-and-security",
  element: <SafetyAndSecurity />,
  loader: () => (document.title = createPageTitle(pageName)),
} as const satisfies RouteObject;

export default SafetyAndSecurity;
